import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPersonFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 24,
	viewBox: "0 -960 960 960",
	width: 24,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M367-527q-47-47-47-113t47-113q47-47 113-47t113 47q47 47 47 113t-47 113q-47 47-113 47t-113-47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Z" })
});
export default SvgPersonFill;
